// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"ee45871a","769":"ff811211"}[chunkId] + ".chunk.css";
};